/**
 * @desc 结束流程
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.Response;
export function request(
  body: defs.activiti.ActivitiDeleteBusinessDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/deleteProcessInstance`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
